export default __webpack_public_path__ + "static/media/bluetechibt.10f5a709.jpg";